/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Cabin {
    First = 'First',
    Business = 'Business',
    PremiumEconomy = 'PremiumEconomy',
    Economy = 'Economy'
}

export function CabinFromJSON(json: any): Cabin {
    return CabinFromJSONTyped(json, false);
}

export function CabinFromJSONTyped(json: any, ignoreDiscriminator: boolean): Cabin {
    return json as Cabin;
}

export function CabinToJSON(value?: Cabin | null): any {
    return value as any;
}

